import { Component } from '@angular/core';
import { TabComponent } from '../../../components/common/tab/tab.component';
import { Tabs } from '../../../core/models/tab-field';
import { BaseLayoutComponent } from '../../base-layout.component';
import { GenerateMappingComponent } from '../generate-mapping/generate-mapping.component';
import { CodeCoverageComponent } from './code-coverage/code-coverage.component';
import { MappingApprovalComponent } from './mapping-approval/mapping-approval.component';
import { RecommendationsComponent } from './recommendations/recommendations.component';

/**
   * This component handles the tabs of code mapping
   */
@Component({
  selector: 'app-code-mappings',
  standalone: true,
  imports: [TabComponent, GenerateMappingComponent],
  templateUrl: './code-mappings.component.html',
  styleUrl: './code-mappings.component.scss'
})
export class CodeMappingsComponent extends BaseLayoutComponent {
  tabs : Tabs[] = [
    {
      label: "Generate Mappings",
      component: GenerateMappingComponent,
      view: 'create_new_test_case',
      disabled: false
    },
    {
      label: "Test Case to Source Code Mapping",
      component: MappingApprovalComponent,
      view: 'versioning_test_cases',
      disabled: true
    },
    {
      label: "Code Coverage",
      component: CodeCoverageComponent,
      view: 'versioning_test_cases',
      disabled: true
    },
    {
      label: "Test Case Recommendation",
      component: RecommendationsComponent,
      view: 'versioning_test_cases',
      disabled: true
    },
  ];
}
